import z from "zod";
import { looseUuid } from "@thalamos/common";
export const TrustIdSchema = looseUuid().brand();
const trustBaseSchema = {
    id: TrustIdSchema,
    name: z.string().min(1).max(255),
    address: z.string().min(1).max(500),
    postalCode: z.string().min(1).max(20),
    emhaOrgId: looseUuid().optional().nullable(),
    odsCode: z.string().max(255).optional().nullable(),
    notListed: z.boolean().optional().nullable(),
};
export const TrustSchema = z
    .object(trustBaseSchema)
    .brand();
export const EnhancedTrustSchema = z
    .object({
    ...trustBaseSchema,
    oid: z.string().max(255).nullable(),
})
    .brand();
//# sourceMappingURL=trust.js.map